import { render, staticRenderFns } from "./AboutProductRetail.vue?vue&type=template&id=7350f0de"
import script from "./AboutProductRetail.vue?vue&type=script&lang=js"
export * from "./AboutProductRetail.vue?vue&type=script&lang=js"
import style0 from "./AboutProductRetail.vue?vue&type=style&index=0&id=7350f0de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports